import { ReviewsSignatureService } from '@weave/schema-gen-ts/dist/schemas/reviews/signature/v1/reviews_signature.pb';
import { bindHTTP } from '@frontend/schema';

export const SchemaReviewsSignatureService = bindHTTP(ReviewsSignatureService);
